import React from 'react';
import PropTypes from 'prop-types';
import { BetPromo } from '../BetPromo';
import CrossPromoCards from '../CrossPromoCards';
import PrizeDrawCard from '../PrizeDrawCard';
import * as Styled from './styles';
import { useSportConfig } from '../../hooks/useSportConfig';

const ResultedState = ({
    title,
    eventName,
    winningSelectionsData,
    TermsLink,
    Itv7TermsLink,
    prize,
    bettingEnabled,
    promotionsConfig
}) => {
    const { config, SelectionCard, mapSelectionToCardProps } = useSportConfig();
    const sportType = config.type;

    const winnersLabel = config.labels.winnersSubtitle(
        eventName,
        winningSelectionsData.length
    );

    return (
        <Styled.ContentWrapper>
            <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
            <Styled.SubTitle>{winnersLabel}</Styled.SubTitle>
            {winningSelectionsData.map((selectionData, index) => (
                <Styled.RunnerCardWrapper key={selectionData.id || index}>
                    <SelectionCard
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...mapSelectionToCardProps(selectionData)}
                    />
                </Styled.RunnerCardWrapper>
            ))}
            <PrizeDrawCard
                eventName={eventName}
                TermsLink={TermsLink}
                hadEntry={false}
                didEntryWin={false}
                prize={prize}
            />
            {config.features.hasPlayItvCta && (
                <>
                    <Styled.PlayItvHeading>
                        More from ITV7
                    </Styled.PlayItvHeading>
                    <Styled.PlayItvWrapper>
                        <CrossPromoCards
                            currentSport={sportType}
                            buttonText="PLAY ITV7"
                            TermsLink={Itv7TermsLink}
                        />
                    </Styled.PlayItvWrapper>
                </>
            )}
            {bettingEnabled && (
                <Styled.BetPromoWrapper>
                    <BetPromo promotionsConfig={promotionsConfig} />
                </Styled.BetPromoWrapper>
            )}
        </Styled.ContentWrapper>
    );
};

ResultedState.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    winningSelectionsData: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            metaData: PropTypes.shape({})
        })
    ).isRequired,
    TermsLink: PropTypes.func.isRequired,
    Itv7TermsLink: PropTypes.func.isRequired,
    bettingEnabled: PropTypes.bool.isRequired,
    promotionsConfig: PropTypes.shape({
        enabled: PropTypes.bool,
        href: PropTypes.string,
        img: PropTypes.shape({
            mobile: PropTypes.string,
            desktop: PropTypes.string
        })
    }).isRequired
};

export default ResultedState;
